module.exports = __webpack_public_path__ + "media/public/images/auth/icon-facebook-e937c879696f6f093e23ab1d8585daa4.svg";